var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVerified20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4 7.6c-.4-.4-1-.4-1.4 0l-4 4-2-2c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l2.7 2.7c.2.2.4.3.7.3.3 0 .5-.1.7-.3L14.4 9c.4-.4.4-1 0-1.4z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNC40IDcuNTk5OEMxNCA3LjE5OTggMTMuNCA3LjE5OTggMTMgNy41OTk4TDguOTk5OTkgMTEuNTk5OEw2Ljk5OTk5IDkuNTk5OEM2LjU5OTk5IDkuMTk5OCA1Ljk5OTk5IDkuMTk5OCA1LjU5OTk5IDkuNTk5OEM1LjE5OTk5IDkuOTk5OCA1LjE5OTk5IDEwLjU5OTggNS41OTk5OSAxMC45OTk4TDguMjk5OTkgMTMuNjk5OEM4LjQ5OTk5IDEzLjg5OTggOC42OTk5OSAxMy45OTk4IDguOTk5OTkgMTMuOTk5OEM5LjI5OTk5IDEzLjk5OTggOS40OTk5OSAxMy44OTk4IDkuNjk5OTkgMTMuNjk5OEwxNC40IDguOTk5OEMxNC44IDguNTk5OCAxNC44IDcuOTk5OCAxNC40IDcuNTk5OFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";
export { SvgVerified20 as ReactComponent };